module.exports = __webpack_public_path__ + "img/French-Guiana.400a1781.png";